export const isPositive = (value: string | number): boolean => Math.sign(Number(value)) === 1;

export const formatPercentage = (value: string | number) => (isPositive(value) ? `+${value}%` : `${value}%`);

/**
 * A common sense function to format a number as a price in GBP.
 * For integers, it formats without decimal places, eg. 1000 -> £1,000
 * For non-integers, it formats with two decimal places, eg. 1000.5 -> £1,000.50
 */
export const formatPrice = (
  value: string | number,
  options?: Intl.NumberFormatOptions,
): string => {
  const number = Number(value);
  const fractionDigits = Number.isInteger(number) ? 0 : 2;

  return new Intl.NumberFormat('en-GB', {
    currency: 'GBP',
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
    style: 'currency',
    ...options,
  }).format(number);
};
